// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "finance.openwallet",
    name: "Open Wallet",
    homepage: "https://openwallet.finance",
    image_id: "68a3c433-d944-4bf6-5093-4ac415fd5400",
    app: {
        browser: "https://openwallet.finance/",
        ios: "https://apps.apple.com/ee/app/open-wallet-keyless-mastery/id6502636684",
        android: "https://play.google.com/store/apps/details?id=com.finverselabs.openwallet&pli=1",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "x-app-open-wallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map